require('./modules/modals');

let headerMenu = document.querySelector('.header-nav');
headerMenu.querySelector('.navbar__toggler').addEventListener('click', () => {
  if (headerMenu.classList.contains('open')) {
    headerMenu.classList.remove('open');
    if (headerMenu.querySelector('.logotype').classList.contains('dark')) {
      headerMenu.querySelector('.logotype').classList.remove('dark');
      headerMenu.querySelector('.logotype').classList.add('light')
    } else {
      headerMenu.querySelector('.logotype').classList.remove('light');
      headerMenu.querySelector('.logotype').classList.add('dark')
    }
    headerMenu.querySelector('.navbar__menu__wr').style.height = '0';
  } else {
    headerMenu.classList.add('open');
    if (headerMenu.querySelector('.logotype').classList.contains('dark')) {
      headerMenu.querySelector('.logotype').classList.remove('dark');
      headerMenu.querySelector('.logotype').classList.add('light')
    } else {
      headerMenu.querySelector('.logotype').classList.remove('light');
      headerMenu.querySelector('.logotype').classList.add('dark')
    }
    headerMenu.querySelector('.navbar__menu__wr').style.height = headerMenu.querySelector('.navbar__menu').scrollHeight + 'px';
  }
});
document.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    headerMenu.classList.add('active')
  } else {
    headerMenu.classList.remove('active')
  }
});

let dropDown = document.querySelectorAll('.drop');

dropDown.forEach(item => {
  item.querySelector('.drop__button').addEventListener('click', () => {
    item.classList.toggle('open')
  })
});

import parallaxCursor from './modules/parallaxCoursor'

parallaxCursor('.parallax-wrapper');

import PureCounter from '@srexi/purecounterjs/js/purecounter';

const pure = new PureCounter;

import $ from 'jquery';

global.jQuery = $;
global.$ = $;

import 'inputmask/dist/jquery.inputmask.min'
import 'ion-rangeslider/js/ion.rangeSlider';

import depCalc from "./modules/depCalc";

$('[data-inputmask]').inputmask();

$(document).on('mousedown', '.irs-handle', function () {
  document.body.style.cursor = 'grabbing';
  $(this).get(0).style.cursor = 'grabbing'
});

let cursorChange = () => {
  document.body.style.cursor = '';
  document.querySelectorAll('.irs-handle').forEach(el => {
    el.style.cursor = ''
  })
};

$(".dep-calc-sum").ionRangeSlider({
  values: [200, 500, 1000, 2500, 20000, 50000],
  from: 3,
  grid: true,
  hide_min_max: true,
  onChange: function (data) {
    document.querySelector('.dep-calc-sum').value = data.from_value;
    document.querySelector('#depCalcSum').innerHTML = data.from_value;
    depCalc();
  },
  onFinish: function (data) {
    cursorChange()
  }
});

$(".dep-calc-day").ionRangeSlider({
  values: [3, 10, 50, 100, 200, 360],
  from: 2,
  grid: true,
  hide_min_max: true,
  onChange: function (data) {
    document.querySelector('.dep-calc-day').value = data.from_value;
    document.querySelector('[data-inputClass=dep-calc-day]').innerHTML = data.from_value;
    depCalc();
  },
  onFinish: function (data) {
    cursorChange()
  }
});

function measureText(txt, font) {
  var id = 'text-width-tester',
      $tag = $('#' + id);
  if (!$tag.length) {
    $tag = $('<span id="' + id + '" style="display:none;font:' + font + ';">' + txt + '</span>');
    $('body').append($tag);
  } else {
    $tag.css({font: font}).html(txt);
  }
  return {
    width: $tag.width(),
    height: $tag.height()
  }
}

function shrinkToFill(input, fontSize, fontWeight, fontFamily) {
  var $input = $(input),
      txt = $input.val(),
      maxWidth = $input.width(),
      font = fontWeight + " " + fontSize + "px " + fontFamily;
  var textWidth = measureText(txt, font).width;
  if (textWidth > maxWidth && fontSize > 30) {
    fontSize = fontSize * maxWidth / textWidth * .9;
    font = fontWeight + " " + fontSize + "px " + fontFamily;
    $('.coin').css({font: font});
  } else {
    $('.coin').css({font: font});
  }
}

import IMask from 'imask';

let form = document.querySelector('.exchange__calc');
if (form) {

  form.querySelectorAll('.coin').forEach(el => {
    var mask = IMask(el, {
      mask: Number,  // enable number mask

      // other options are optional with defaults below
      scale: 2,  // digits after point, 0 for integers
      signed: false,  // disallow negative
      thousandsSeparator: '',  // any single char
      padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
      normalizeZeros: true,  // appends or removes zeros at ends
      radix: '.',  // fractional delimiter
      mapToRadix: [','],  // symbols to process as radix

      // additional number interval options (e.g.)
      min: 0,
      max: 10000
    });
  });

  let value = document.querySelector('[name=coin]:checked').value;
  form.querySelectorAll('.coin').forEach(el => {
    el.addEventListener('input', e => {
      if (e.target.id == 'criptoCoin') {
        document.getElementById('usdCoin').value = (e.target.value / value).toFixed(2);
      } else {
        document.getElementById('criptoCoin').value = (e.target.value * value).toFixed(2);
      }
      shrinkToFill('#criptoCoin', 56, "bold", "Gotham Pro, sans-serif");
    })
  });

  form.querySelectorAll('[name=coin]').forEach(item => {
    item.addEventListener('click', e => {
      let id = e.target.id,
          label = document.getElementById('criptoCoinLabel');
      label.innerHTML = id;
      value = document.getElementById(id).value;
      document.getElementById('criptoCoin').value = (document.getElementById('usdCoin').value * value).toFixed(2);
      shrinkToFill('#criptoCoin', 56, "bold", "Gotham Pro, sans-serif");
    })
  })
}

$('.language-setup > .language-setup__flag').mouseover(function () {
  $(this).parent().addClass('active')
});

$('.language-setup__dropdown-menu').mouseleave(function () {
  $(this).parent().removeClass('active')
});

require('./modules/translate');

$('.language-setup__dropdown-item').on('click', function (e) {
  e.preventDefault();
  doGTranslate('ru|' + $(this).data('lang'))
});

let steps = document.querySelector('.steps');
if (steps && window.innerWidth > 992) {
  steps.querySelectorAll('.steps__block').forEach(el => {
    el.addEventListener('mouseenter', e => {
      steps.querySelector('.steps__bg-line__block:nth-child(' + Number(el.querySelector('.steps__number').innerHTML) + ')').classList.add('hovered')
    });
    el.addEventListener('mouseleave', e => {
      steps.querySelector('.steps__bg-line__block:nth-child(' + Number(el.querySelector('.steps__number').innerHTML) + ')').classList.remove('hovered')
    })
  })
}

document.addEventListener('click', e => {
  if (!e.target.classList.contains('dot')) {
    document.querySelectorAll('.reviews__item').forEach(elem => {
      elem.classList.remove('active')
    });
  }
});

document.querySelectorAll('.reviews__item').forEach(el => {
  el.querySelector('.dot').addEventListener('click', e => {
    document.querySelectorAll('.reviews__item').forEach(elem => {
      elem.classList.remove('active')
    });
    el.classList.add('active');
    let trans = Number(getComputedStyle(el.querySelector('.reviews__block')).getPropertyValue("transform").match(/(-?[0-9\.]+)/g)[4]),
        right = el.querySelector('.reviews__block').getBoundingClientRect().right,
        left = el.querySelector('.reviews__block').getBoundingClientRect().left;
    if (left < 15) {
      el.querySelector('.reviews__block').style.transform = 'translateX(' + (trans - left + 15) + 'px)'
    }
    if (right > window.innerWidth - 15) {
      el.querySelector('.reviews__block').style.transform = 'translateX(' + (trans + window.innerWidth - 15 - right) + 'px)'
    }
  })
});

let accordion = document.getElementById('faqAccordion');
if (accordion) {
  let mB = (window.innerWidth < 768) ? 15 : 30;
  accordion.querySelector('.faq-accordion__group.open p').style.height = accordion.querySelector('.faq-accordion__group.open p').scrollHeight + mB + 'px';
  let accordionBlocks = accordion.querySelectorAll('.faq-accordion__group');
  accordionBlocks.forEach(item => {
    let pHeight = item.querySelector('p').scrollHeight + mB + 'px';
    item.querySelector('h3, h3 *').addEventListener('click', () => {
      accordionBlocks.forEach(i => {
        i.classList.remove('open');
        i.querySelector('p').style.height = '';
      });
      if (item.classList.contains('open')) {
        item.classList.remove('open');
        item.querySelector('p').style.height = '';
      } else {
        item.classList.add('open');
        item.querySelector('p').style.height = pHeight;
      }
    })
  })
}

let infoWr = document.querySelector('.info-tabs');
if (infoWr) {
  infoWr.querySelectorAll('.info-tabs__link').forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();
      infoWr.querySelector('.info-tabs__link.active').classList.remove('active');
      infoWr.querySelector('.info-tabs__block.active').classList.remove('active');
      e.target.classList.add('active');
      infoWr.querySelector(e.target.getAttribute('href')).classList.add('active');
    })
  })
}


let animateLabel = labels => {
  if (!labels.length) {
    return
  }
  labels.forEach(item => {
    item.querySelector('input').addEventListener('focusin', () => {
      item.classList.add('focus')
    });
    item.querySelector('input').addEventListener('focusout', () => {
      item.classList.remove('focus')
    })
  })
};

global.animateLabel = animateLabel;

animateLabel(document.querySelectorAll('label.animate'));

import Swiper from 'swiper'

if (window.innerWidth <= 768 && document.querySelector('.about-page')) {
  var mySwiper = new Swiper('.swiper-container', {
    loop: false,
    spaceBetween: 15,
    slidesPerView: 1.2,
    setWrapperSize: true,
    grabCursor: true
  })
}

function imgModalOpen(item) {

  if (!item) {
    console.warn('imgModalOpen called with empty item');
    return;
  }

  let imgModalHtml = (img) => {
    let html = '<div id="imgModal" class="img-modal">\n' +
        '<button class="img-modal__close"><img src="/img/close.svg" alt=""></button>\n' +
        '  <img src="' + img + '" alt="">\n' +
        '</div>';
    return html
  };

  let imgUrl = item.getAttribute('data-img');
  item.addEventListener('click', e => {
    e.preventDefault();
    document.body.insertAdjacentHTML('beforeEnd', imgModalHtml(imgUrl));
    document.querySelectorAll('#imgModal .modal__close, #imgModal .modal__close *, #imgModal').forEach(closeItem => {
      closeItem.addEventListener('click', () => {
        document.querySelector('#imgModal').remove();
      })
    })
  })
}

document.querySelectorAll('[data-img]').forEach(item => {
  imgModalOpen(item);
});

import Chart from 'chart.js';
import moment from 'moment';

require('air-datepicker/dist/js/datepicker.min');


let myChart = null;
var chartStart = moment().subtract(1, 'week').toDate();
var chartEnd = moment().add(1, 'day').toDate();
global.myChart = myChart;

let groupedByDate = [];
let values = {};

export let updateData = function (chartData) {
  groupedByDate = [];
  values = {};

  chartData = chartData || [];

  chartData = chartData.reverse();

  chartData.forEach((item, i) => {
    var dateString = moment.unix(item.time).format('DD.MM.YYYY');
    var valuesForDate = values[dateString] || {};

    if (typeof values[dateString] === 'undefined') {
      values[dateString] = {};
    }
    values[dateString][item.operation] = parseFloat(valuesForDate[item.operation] || 0) + parseFloat(item.value);
    groupedByDate[dateString] = item;
  });

  if (myChart) {
    myChart.data.datasets[0].data = [];
    myChart.data.datasets[1].data = [];

    var loop = new Date(chartStart);
    while (loop <= chartEnd) {

      var newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);

      var loopDateString = moment(newDate).format('DD.MM.YYYY');

      myChart.data.datasets[0].data.push({
        x: newDate,
        y: (typeof values[loopDateString] !== 'undefined') ? parseFloat(values[loopDateString]['income'] || 0) : 0
      });
      myChart.data.datasets[1].data.push({
        x: newDate,
        y: (typeof values[loopDateString] !== 'undefined') ? parseFloat(values[loopDateString]['expense'] || 0) : 0
      });
    }
    myChart.update();
  }
};

let chartCanvas = document.getElementById("history-chart");
if (chartCanvas) {
  const ctx = chartCanvas.getContext("2d");

  moment.locale('ru');

  let chartData = JSON.parse(document.querySelector('#history-chart').dataset.data);
  updateData(chartData);

  var defaultStart = moment().subtract(1, 'week').toDate();
  var defaultEnd = moment().add(1, 'day').toDate();

  function recalcByDate(start, end) {
    chartStart = start;
    chartEnd = end;
    if (myChart) {
      myChart.destroy();
    }
    myChart = new Chart(ctx, {
      type: 'line',
      data: {
        datasets: [{
          backgroundColor: 'transparent',
          borderColor: 'rgba(35, 212, 176, 0.3)',
          borderWidth: 3
        },
          {
            backgroundColor: 'transparent',
            borderColor: 'rgba(238, 135, 60, 0.3)',
            borderWidth: 3
          }
        ],
        pointHitRadius: 1,
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.yLabel;
            }
          }
        }
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scaleShowValues: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              unit: 'day',
              tooltipFormat: 'll'
            },
            stacked: true,
            gridLines: {
              display: false
            },
            ticks: {
              autoSkip: false
            }
          }]
        },
        animation: {
          easing: "easeInOutBack"
        },
        legend: {
          display: false
        },
        elements: {
          point: {
            radius: 2,
            hitRadius: 30,
            hoverRadius: 2,
            borderWidth: 0,
            borderColor: '#00ff00'
          },
          line: {
            tension: 0.3
          }
        },
        tooltips: {
          enabled: false,
          mode: 'index',
          position: 'nearest',
          yAlign: 'bottom',
          custom: function (tooltip) {

            if (typeof tooltip.dataPoints === 'undefined') {
              return;
            }

            // Tooltip Element
            var tooltipEl = document.querySelector('#chartjs-tooltip');
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
            }
            tooltipEl.classList.add('graphic__indicator');
            tooltipEl.id = 'chartjs-tooltip';

            // 0 -income
            // 1 -expense

            tooltipEl.innerHTML = '\t\t\t\t\t\t\t\t\t<span class="title">' + (tooltip.dataPoints[0].yLabel > 0 ? '+' + tooltip.dataPoints[0].yLabel : '0') + ' ₽</span>\n' +
                '\t\t\t\t\t\t\t\t\t<span class="value">' + (tooltip.dataPoints[1].yLabel ? (tooltip.dataPoints[1].yLabel ? '-' + tooltip.dataPoints[1].yLabel + ' ₽' : '') : '0 ₽') + '</span>\n' +
                '\t\t\t\t\t\t\t\t\t<span class="date">' + tooltip.dataPoints[0].xLabel + '</span>\n' +
                '\t\t\t\t\t\t\t\t\t<div class="graphic__dot"><div></div></div><div></div>\n';
            this._chart.canvas.parentNode.appendChild(tooltipEl);

            // Hide if no tooltip
            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltip.yAlign) {
              tooltipEl.classList.add(tooltip.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            var positionY = this._chart.canvas.offsetTop;
            var positionX = this._chart.canvas.offsetLeft;

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = positionX + tooltip.caretX + 'px';
            tooltipEl.style.top = positionY + tooltip.caretY + 'px';
            tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
            tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
            tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';

            //myChart.update();
          }
        }

      }
    });

    var loop = new Date(start);
    while (loop <= end) {

      var newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);

      var loopDateString = moment(newDate).format('DD.MM.YYYY');

      myChart.data.datasets[0].data.push({
        x: newDate,
        y: (typeof values[loopDateString] !== 'undefined') ? parseFloat(values[loopDateString]['income'] || 0) : 0
      });
      myChart.data.datasets[1].data.push({
        x: newDate,
        y: (typeof values[loopDateString] !== 'undefined') ? parseFloat(values[loopDateString]['expense'] || 0) : 0
      });
    }
    myChart.update();
  }

  recalcByDate(defaultStart, defaultEnd);

  var myDatepicker = $('.graphic-period__values').datepicker({
    range: true,
    onSelect: function onSelect(fd, date) {
      recalcByDate(date[0], date[1] || defaultEnd);
      $('.graphic-period__from-date').text(moment(date[0]).format('D MMM YYYY'));
      $('.graphic-period__to-date').text(moment(date[1] || defaultEnd).format('D MMM YYYY'));
    },
    position: "bottom right"
  }).data('datepicker');
  myDatepicker.selectDate([defaultStart, defaultEnd]);
  document.querySelector('.graphic-period')
  && document.querySelector('.graphic-period').addEventListener('click', (e) => {
    e.preventDefault();
    myDatepicker.show();
  });

  $('.cabinet-graphic-period').on('click', function (e) {
    e.preventDefault();

    let date = null;

    let today = moment();

    switch ($(this).data('period')) {
      case 'today':
        date = today;
        break;
      case 'week':
        date = moment().subtract(1, 'week');
        break;
      case 'month':
        date = moment().subtract(1, 'month');
        break;
      case 'year':
        date = moment().subtract(1, 'year');
        break;
    }
    myDatepicker.selectDate([date.toDate(), today.toDate()]);
  });
}

document.querySelectorAll('.selector').forEach(selector => {
  let input = selector.querySelector('input'),
      items = selector.querySelectorAll('.selector__item');
  selector.querySelector('.selector__button').addEventListener('click', () => {
    selector.classList.toggle('open')
  });
  items.forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();
      selector.querySelector('.selector__button').innerHTML = e.target.innerHTML;
      selector.querySelector('.selector__item.d-none').classList.remove('d-none');
      e.target.classList.add('d-none');
      input.value = e.target.value;
      selector.classList.remove('open');
    })
  })
});

document.querySelectorAll('.card-input').forEach(cardBlock => {
  cardBlock.querySelectorAll('input').forEach(input => {
    let mask = IMask(input, {
      mask: '0000'
    });
    input.addEventListener('input', e => {
      if (e.target.value.length >= 4) {
        e.target.nextElementSibling.focus()
      } else if (e.inputType == 'deleteContentBackward' && e.target.value.length < 1) {
        e.target.previousElementSibling.focus()
      }
    })
  })
});

if (document.querySelector('.cabinet__warning')) {
  document.querySelectorAll('.cabinet__warning__close, .cabinet__warning__close *').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelector('.cabinet__warning').remove();
    })
  })
}

let payTabs = document.querySelector('#payTabs');
if (payTabs) {
  payTabs.querySelectorAll('.pay-tabs__link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      payTabs.querySelector('.pay-tabs__link.active').classList.remove('active');
      e.target.classList.add('active');
      let toggleClass = e.target.getAttribute('data-toggle');
      if (toggleClass == 'all') {
        payTabs.querySelectorAll('.pay-block.d-none').forEach(payTab => {
          payTab.classList.remove('d-none');
        })
      } else {
        payTabs.querySelectorAll('.pay-block').forEach(payTab => {
          payTab.classList.add('d-none');
        });
        payTabs.querySelectorAll('.pay-block.' + toggleClass).forEach(payTab => {
          payTab.classList.remove('d-none');
        })
      }
    })
  });

  payTabs.querySelectorAll('.pay-block').forEach(payTab => {
    payTab.addEventListener('click', () => {
      alert("Недоступно. Ограниченный режим.");
    })
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.cabinet-page') && window.innerWidth >= 992) {
    let nav = document.querySelector('.cabinet-nav'),
        footer = document.querySelector('.footer');
    if (footer.getBoundingClientRect().top <= window.innerHeight) {
      nav.style.bottom = window.innerHeight - footer.getBoundingClientRect().top + 30 + 'px'
    } else {
      nav.style.bottom = '30px'
    }
    window.addEventListener('scroll', () => {
      if (footer.getBoundingClientRect().top <= window.innerHeight) {
        nav.style.bottom = window.innerHeight - footer.getBoundingClientRect().top + 30 + 'px'
      } else {
        nav.style.bottom = '30px'
      }
    })
  }
});

function onCardChange() {
  let operations = document.querySelector('.cabinet__operations');
  if (operations) {
    operations.querySelectorAll('.cabinet__operations__link').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        if (window.innerWidth <= 768) {
          operations.querySelector('.cabinet__operations__header').classList.toggle('open')
        }
        operations.querySelector('.cabinet__operations__tab.active').classList.remove('active');
        operations.querySelector('.cabinet__operations__link.active').classList.remove('active');
        operations.querySelector(e.target.getAttribute('href')).classList.add('active');
        e.target.classList.add('active');
      })
    });
    imgModalOpen(document.querySelector('.button-qr'));
  }
  onPaginate();
}

$(window).on('card-changed', function () {
  onCardChange();
});
onCardChange();

function onPaginate() {
  $('.transaction-paginator__prev, .transaction-paginator__next, .transaction-paginator__item').on('click', function (e) {
    e.preventDefault();

    let page = $(this).data('page');

    $.ajax('?page=' + page, {
      dataType: 'html',
      success: function (response) {
        $('.cabinet__operations__tab#operation_1').html($(response).find('.cabinet__operations__tab').html());
        onPaginate();
      }
    });
  });
}

onPaginate();

let openCard = card => {
  let cardHtml = card.outerHTML,
      html = '<div class="modal-card modal" id="cardModal">' + cardHtml + '</div>';
  document.body.insertAdjacentHTML('beforeEnd', html);
  document.querySelector('#cardModal').addEventListener('click', e => {
    if (!e.target.closest('.card-svg')) {
      document.querySelector('#cardModal').remove();
      return;
    } else if (e.target.closest('.card-svg__button') || e.target.classList.contains('card-svg__button')) {
      e.target.closest('.card-svg').querySelector('.card-svg__back').style.display = 'block';
      return;
    } else if (e.target.closest('.card-svg__back') || e.target.classList.contains('card-svg__back')) {
      e.target.closest('.card-svg').querySelector('.card-svg__back').style.display = 'none';
      return;
    }
  })
}

$('.cabinet__block__body .card-wrapper').on('click', function (e) {
  e.preventDefault();
  if ($(e.target).parents('.card-svg__button')[0]) {
    $(e.target).parents('.card-svg').find('.card-svg__back').css('display', 'block');
    $(e.target).parents('.card-svg').find('.card-svg__back').on('click', () => {
      $(e.target).parents('.card-svg').find('.card-svg__back').css('display', 'none');
    });
    return;
  }
  if ($(e.target).parents('.card-svg__back')[0]) {
    $(e.target).parents('.card-svg').find('.card-svg__back').css('display', 'none');
    return;
  }
  if ($(e.target).parents('.info-wrap').find('svg')[0]) {
    let elem = $(e.target).parents('.info-wrap').find('span'),
        code = elem.html();
    elem.html(elem.data('value'));
    elem.data('value', code);
    return;
  }
  if ($(e.target).parents('.card-svg')[0] && window.innerWidth > 768) {
    openCard($(e.target).parents('.card-svg')[0]);
    return;
  }
  if ($(e.target).hasClass('.card-svg') && window.innerWidth > 768) {
    openCard($(e.target).parents('.card-svg')[0]);
    return;
  }
  $('.cabinet__block__body .card-wrapper').removeClass('active');
  let cardType = $(this).data('type');
  let $card = $(this);
  $.ajax('?card=' + cardType, {
    dataType: 'html',
    success: function (response) {
      $card.addClass('active');
      //$('.cabinet__charr').html($(response).find('.cabinet__charr').html());
      myChart.update();
      $('.cabinet__operations').html($(response).find('.cabinet__operations').html());
      $('#identifyModalButton').toggleClass('d-none', $(response).find('#identifyModalButton').hasClass('d-none'));

      window.dispatchEvent(new Event('card-changed'));

      let loadedChartData = $(response).find('#history-chart').data('data');

      updateData(loadedChartData);
      myChart.update();
    }
  });
});

function chatScroll() {
  let chatEl = $('.chat').get(0);

  if (!chatEl) {
    return;
  }

  document.querySelector('.chat').scrollTop = chatEl.scrollHeight;
}

$('.file-selection .file-selection__input').on('change', function (e) {
  let filename = e.target.files[0].name;
  $(this).parents('.support__form__buttons-wrapper').find('.file-selection__name').text(filename);
});

require('./modules/exchanger');

let bodyScrollLock = require('body-scroll-lock'),
    disableBodyScroll = bodyScrollLock.disableBodyScroll,
    enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.querySelectorAll('[data-modal=identifyModalButton]').forEach(button => {
  button.addEventListener('click', e => {
    e.preventDefault();
    disableBodyScroll('#identifyModal .popup__content');
    document.querySelector('#identifyModal').classList.remove('d-none');
    document.querySelectorAll('#identifyModal .close, #identifyModal .close img, #identifyModal .popup__background').forEach(close => {
      close.addEventListener('click', () => {
        document.querySelector('#identifyModal').classList.add('d-none');
        enableBodyScroll('#identifyModal .popup__content');
      })
    })
  })
});

document.querySelectorAll('[data-modal=requisitesModalButton]').forEach(button => {
  button.addEventListener('click', e => {
    e.preventDefault();
    disableBodyScroll('#requisitesModal .popup__content');
    document.querySelector('#requisitesModal').classList.remove('d-none');
    document.querySelectorAll('#requisitesModal .close, #requisitesModal .close img, #requisitesModal .popup__background').forEach(close => {
      close.addEventListener('click', () => {
        document.querySelector('#requisitesModal').classList.add('d-none');
        enableBodyScroll('#requisitesModal .popup__content');
      })
    })
  })
});

document.querySelectorAll('[data-modal=takeOff]').forEach(button => {
  button.addEventListener('click', e => {
    e.preventDefault();
    disableBodyScroll('#takeOff .popup__content');
    document.querySelector('#takeOff').classList.remove('d-none');
    document.querySelectorAll('#takeOff .close, #takeOff .close img, #takeOff .popup__background').forEach(close => {
      close.addEventListener('click', () => {
        document.querySelector('#takeOff').classList.add('d-none');
        enableBodyScroll('#takeOff .popup__content');
      })
    })
  })
});

let toastr = require('toastr/build/toastr.min');
window.toastr = toastr;

const copyToClipBoard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  const result = document.execCommand('copy');
  document.body.removeChild(el);
  return result;
};


$('.copy-link').on('click', function (e) {
  e.preventDefault();
  var copyText = $('.requisites__body div').not('.requisites__cripto').text();

  /* Copy the text inside the text field */
  if (copyToClipBoard(copyText)) {
    toastr.success("Скопировано в буфер обмена");
  } else {
    toastr.error("Ошибка копирования в буфер обмена");
  }

});

import './pages/profile';
import './pages/help';
